import VueLazyload from 'vue3-lazyload'
import { createApp, ref, onMounted, computed } from 'vue';

const professionalsList = createApp({
    name: 'professionals-list',
    setup() {
        const professionals = ref(window.app.professionals);
        const search = ref("");

        const filteredProfessionals = computed(() => {
            if(!search.value) return professionals.value;

            return professionals.value.filter(professional => {
                return professional.name.toLowerCase().includes(search.value.toLowerCase())
                    || professional.disciplines.toLowerCase().includes(search.value.toLowerCase())
                    || professional.county.toLowerCase().includes(search.value.toLowerCase())
            })
        });

        const handleImageLoaded = (event) => {
            $(event.target).closest('.image-wrapper').removeClass('image-loading');
        };

        return {
            professionals,
            search,
            filteredProfessionals,
            handleImageLoaded
        }
    }
});
professionalsList.use(VueLazyload);
professionalsList.mount(".professionals-list-app");
